import {Action, createFeatureSelector, createReducer, createSelector, on} from '@ngrx/store';
import * as fromActions from './indication-actions';
import {IndicationBasicModel} from '@core/modules/rest/indication/response/indication-basic.model';
import {AppStateNameEnum} from '@core/enums/app-state-name.enum';

export const REDUCER_NAME = AppStateNameEnum.feature_indication_basic;

export interface State {
    indication: IndicationBasicModel;
    indications: IndicationBasicModel[];
    loading: boolean;
}

const initialState: State = {
    indication: null,
    indications: [],
    loading: false
};

const stateSelector = createFeatureSelector<State>(REDUCER_NAME);

export const indicationSelector = createSelector(stateSelector, (state: State) => state.indication);
export const indicationsSelector = createSelector(stateSelector, (state: State) => state.indications);
export const loadingSelector = createSelector(stateSelector, (state: State) => state.loading);

const innerReducer = createReducer(
    initialState,
    on(fromActions.GetIndications, ((state: State): State => ({
        ...state,
        loading: true
    }))),
    on(fromActions.GetIndicationsSuccess, ((state: State, {indications}): State => ({
        ...state,
        indications,
        loading: false
    }))),
    on(fromActions.GetIndication, ((state: State): State => ({
        ...state,
        loading: true
    }))),
    on(fromActions.GetIndicationSuccess, ((state: State, {indication}): State => ({
        ...state,
        indication,
        loading: false
    }))),
    on(fromActions.CloneIndication, ((state: State): State => ({
        ...state,
        loading: true
    }))),
    on(fromActions.CloneIndicationSuccess, ((state: State, {indication}): State => ({
        ...state,
        indications: [...state.indications, indication],
        loading: false
    }))),
    on(fromActions.SaveIndication, ((state: State): State => ({
        ...state,
        loading: true
    }))),
    on(fromActions.SaveIndicationSuccess, ((state: State, {indication}): State => {
        const indicationInArray = state.indications.find(item => item.id === indication.id);
        let indicationsNew;
        if (indicationInArray) {
            const index = state.indications.indexOf(indicationInArray);
            indicationsNew = [...state.indications];
            indicationsNew.splice(index, 1, indication);
        } else {
            indicationsNew = [...state.indications, indication];
        }
        return {
            ...state,
            indications: indicationsNew,
            loading: false
        };
    }))
);

export function indicationReducer(state: State | undefined, action: Action): State {
    return innerReducer(state, action);
}
